<template>
  <div id="app">
    <VideoPlayer v-bind:options="videoOptions"/>
  </div>
</template>

<script>
import Player from './components/player.vue'
import "video.js/dist/video-js.css";

const appElement = document.getElementById('player_data')
const appSettings = JSON.parse(appElement.getAttribute('data-settings'))

export default {
  name: 'App',
  components: {
    VideoPlayer: Player
  },
  data() {
    return {
      videoOptions: {
        autoplay: true,
        controls: true,
        fluid: true,
        liveui: true,
        responsive: true,
        sources: [
          {
            src: appSettings.playerSrc,
            type: "application/dash+xml"  //"video/mp4"
          }
        ]
      }
    };
  }
}
</script>

<style></style>
